var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"月次請求処理（パートナー会社）","icon":"fas fa-file-invoice-dollar"}},[_c('partner-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }